/**
 * Внутренний URL страницы врача с trailing slash.
 */
export default function getDoctorPageUrl(
  reverseFullL10N: (_payload: {
    name: string
    args: {
      language: string | null
      town_translit: string
      doctor_translit: string
    }
  }) => string,
  payload: {
    language: string | null
    townTranslit: string
    doctorTranslit: string
  },
): string {
  return reverseFullL10N({
    name: 'doctor',
    args: {
      language: payload.language,
      town_translit: payload.townTranslit,
      doctor_translit: payload.doctorTranslit,
    },
  })
}
